export default __webpack_public_path__ + "static/media/pg-48.140a8375.jpg";